import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            商务合作、内容投稿、问题反馈，我们随时倾听你的声音
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-200/60 p-6 md:p-10">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center">
              {contactInfo.desc}
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div className="flex items-center gap-4 bg-background-50 rounded-xl p-5 border border-background-200/40">
                <div className="w-11 h-11 rounded-xl bg-primary-100/70 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-xl text-primary-600" />
                </div>
                <div className="min-w-0">
                  <div className="text-xs text-foreground-400 mb-0.5">电子邮箱</div>
                  <div className="text-sm font-medium text-foreground-950 truncate">
                    {contactInfo.email}
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-4 bg-background-50 rounded-xl p-5 border border-background-200/40">
                <div className="w-11 h-11 rounded-xl bg-accent-100/70 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-xl text-accent-600" />
                </div>
                <div className="min-w-0">
                  <div className="text-xs text-foreground-400 mb-0.5">微信公众号</div>
                  <div className="text-sm font-medium text-foreground-950 truncate">
                    {contactInfo.wechat}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}